"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuntimePlatform = exports.SubjectType = exports.ServiceError = void 0;
/**
 * Represents an error as returned by our public API.
 *
 * @property code The unique error code.
 * @property details The human-readable error message.
 * @property field The optional field subject of the error.
 * @property value The optional field value that triggered the error.
 */
class ServiceError {
    code;
    details;
    field;
    value;
    constructor(code, details, field, value) {
        this.code = code;
        this.details = details;
        this.field = field;
        this.value = value;
        this.code = code;
        this.details = details;
        this.field = field;
        this.value = value;
    }
}
exports.ServiceError = ServiceError;
/**
 * Represents the type of a subject identifier.
 * Subject types are used to describe the kind of identifier used to identify a subject
 * being assigned a specific feature variant. This is used to keep track of the scope of
 * an assignment and being able to report its value being assigned.
 */
var SubjectType;
(function (SubjectType) {
    /**
     * Represents an anonymous subject identifier.
     */
    SubjectType[SubjectType["ANONYMOUS_ID"] = 1] = "ANONYMOUS_ID";
    /**
     * Represents a subject key being a user token.
     */
    SubjectType[SubjectType["USER_TOKEN"] = 2] = "USER_TOKEN";
    /**
     * Represents a subject key being a business token.
     */
    SubjectType[SubjectType["BUSINESS_TOKEN"] = 3] = "BUSINESS_TOKEN";
    /**
     * Represents a subject key being a user guid (a legacy business member identifier).
     * @deprecated Use USER_TOKEN instead.
     */
    SubjectType[SubjectType["USER_GUID"] = 4] = "USER_GUID";
    /**
     * Represents a subject key being a business guid (a legacy business identifier).
     * @deprecated Use BUSINESS_TOKEN instead.
     */
    SubjectType[SubjectType["BUSINESS_GUID"] = 5] = "BUSINESS_GUID";
})(SubjectType = exports.SubjectType || (exports.SubjectType = {}));
/**
 * Represents the type of scope applicable to a policy.
 */
var RuntimePlatform;
(function (RuntimePlatform) {
    // Represents the iOS platform
    RuntimePlatform[RuntimePlatform["IOS"] = 0] = "IOS";
    // Represents the Android platform
    RuntimePlatform[RuntimePlatform["ANDROID"] = 1] = "ANDROID";
    // Represents a browser-based platform
    RuntimePlatform[RuntimePlatform["WEB"] = 2] = "WEB";
})(RuntimePlatform = exports.RuntimePlatform || (exports.RuntimePlatform = {}));
